import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { buildMedNecExtraReducers } from './extraReducers';
import {
  coreReducers,
  clinicalReducers,
  editTrackingReducers,
  filterReducers,
  draftReducers,
} from './reducers';

const medNecCaseSlice = createSlice({
  name: 'medNecCase',
  initialState,
  reducers: {
    ...coreReducers,
    ...clinicalReducers,
    ...editTrackingReducers,
    ...filterReducers,
    ...draftReducers,
  },
  extraReducers: buildMedNecExtraReducers,
});

export const {
  // Core
  setCurrentCase,
  updateCase,
  clearCase,
  setSelectedCaseId,
  // Clinical
  updatePhysician,
  updateIcdCodes,
  updateCptCodes,
  updateLevelOfCare,
  updateNotes,
  updatePayerInfo,
  // Edit tracking
  markAsSaved,
  discardChanges,
  resetCase,
  // Filters
  setStatusFilter,
  setFacilityFilter,
  clearFilters,
  // Draft
  initDraft,
  updateDraft,
  updateDraftPatient,
  clearDraft,
} = medNecCaseSlice.actions;

export default medNecCaseSlice.reducer;
